import Navigator from "../../../../publicComponent/h5/Navigator";
import {useEffect} from "react";
import {useNavigateTo} from "../../../../hooks/useNavigateTo";
import {mediaMatch} from "../../../../utils";
import {useTranslation} from "react-i18next";
import ForgetPwdForm from "../../../../publicComponent/ForgetPwdForm";
import {HeaderMall9} from "../../../../publicComponent/Header";
import RegisterForm from "../../../../publicComponent/RegisterForm";
import bg from "../login/bg.png";
import Button from "../../../../publicComponent/Button";
import cookies from "../../../../utils/cookies";

function ForgetPwdFormMall9(props) {
  const agentInfo = cookies.getAgentInfo()
  const {
    t,
    query,
    loading,
    countdown,
    inputHandle,
    getVerCode,
    forgetPwdHandle,
  } = props;
  
  return (
    <div className="w-[850px] bg-white mx-auto flex"
         style={{ boxShadow: '0 5px 12px rgba(0,0,0,.15)' }}>
      <div className="w-[375px] flex-none bg-[#333]">
        <img src={bg}/>
      </div>
      <div className="flex-1 px-[60px] py-[40px] pt-[30px]">
        <h1 className="text-[24px] text-center font-bold mb-[20px]">{t('忘记密码')}</h1>
        <div className="mb-[20px]">
          <label className="text-[14px] hidden mb-[5px] md:block inp-must must-right">
            {agentInfo.isAllowMobileno === '1' && t('手机号') + '/'}{t('邮箱')}
          </label>
          <input type="text"
                 placeholder={`${t('请输入')}${agentInfo.isAllowMobileno === '1'? t('手机号') + '/': '' }${t('邮箱')}`}
                 value={query.account}
                 onChange={(e) => inputHandle(e, 'account')}
                 className="p-[12px] w-[100%] bg-[#f4f4f6] rounded-[5px] text-[15px]"/>
        </div>
        
        <div className="mb-[20px]">
          <label className="text-[14px] hidden mb-[5px] md:block inp-must must-right">
            {t('验证码')}
          </label>
          <div className="flex">
            <input type="password"
                   placeholder={`${t('请输入')}${t('验证码')}`}
                   value={query.verifyCode}
                   onChange={(e) => inputHandle(e, 'verifyCode')}
                   className="p-[12px] w-[100%] bg-[#f4f4f6] rounded-[5px] text-[15px]"/>
            <Button onClick={getVerCode}
                    disabled={countdown > 0}
                    className={'rounded-[5px] ml-[8px] bg-[#333] text-white w-[180px] text-[14px]'}>
              {
                countdown > 0
                  ? `${Math.round(countdown / 1000)}s`
                  : t('获取验证码')
              }
            </Button>
          </div>
        </div>
        
        <div className="mb-[20px]">
          <label className="text-[14px] hidden mb-[5px] md:block inp-must must-right">
            {t('密码')}
          </label>
          <input type="password"
                 placeholder={`${t('请输入')}${t('密码')}`}
                 value={query.pwd}
                 onChange={(e) => inputHandle(e, 'pwd')}
                 className="p-[12px] w-[100%] bg-[#f4f4f6] rounded-[5px] text-[15px]"/>
        </div>
        
        <div className="mb-[30px]">
          <label className="text-[14px] hidden mb-[5px] md:block inp-must must-right">
            {t('重复密码')}
          </label>
          <input type="password"
                 placeholder={`${t('请输入')}${t('重复密码')}`}
                 value={query.confirmPwd}
                 onChange={(e) => inputHandle(e, 'confirmPwd')}
                 className="p-[12px] w-[100%] bg-[#f4f4f6] rounded-[5px] text-[15px]"/>
        </div>
        
        <Button className="rounded-[5px] w-[100%] text-white mb-[5px]
                         py-[12px] bg-[#444] text-[14px]"
                loading={loading}
                onClick={forgetPwdHandle}>{t('提交')}</Button>
      
      </div>
    </div>
  );
}

export default function ForgetPwd() {
  const navigateTo = useNavigateTo();
  const isMdmax = mediaMatch.isMdmax;
  const { t } = useTranslation();
  const agentInfo = cookies.getAgentInfo();
  
  return (
    <>
      <div className="md:bg-[#f0f0f0] h-[100vh] mdmax:hidden">
        <HeaderMall9/>
        <div className="flex items-center mdmax:hidden"
             style={{ height: window.innerHeight - 150 }}>
          <ForgetPwdForm>
            {(props) => (<ForgetPwdFormMall9 {...props}/>)}
          </ForgetPwdForm>
        </div>
      </div>
      <div className="md:hidden">
        <Navigator title={agentInfo.agentName} goback/>
        <Navigator.container>
          <div className={'px-[18px]'}>
            <h1 className={'pt-[18%] pb-[8%] text-center text-3xl'}>{t('忘记密码')}</h1>
            <ForgetPwdForm></ForgetPwdForm>
          </div>
        </Navigator.container>
      </div>
    </>
  );
}
